import { t } from "@/i18n";
export const SITE_NAME = "MyMenuProfit";

const PRIVATE = { robots: "noindex, nofollow" };

export const SEO = {
  "/": {
    title: t("seo.mymenuprofit_calculez_la_rentabilite_de_ch"),
    description: t("seo.logiciel_ia_pour_restaurateurs_importez_vo"),
  },
  "/analyser-ma-carte": {
    title: t("seo.analyse_de_carte_gratuite_pour_restaurant"),
    description: t("seo.importez_la_carte_de_votre_restaurant_en_p"),
  },
  "/tarifs": {
    title: t("seo.pricing_title"),
    description: t("seo.pricing_desc"),
  },
  "/login": {
    title: t("seo.connexion_mymenuprofit_rentabilite_de_menu"),
    description: t("seo.connectez_vous_a_mymenuprofit_pour_suivre"),
    heading: t("seo.votre_tableau_de_bord_de_rentabilite_en_un"),
    body: [
      t("seo.en_vous_connectant_a_mymenuprofit_vous_ret"),
      t("seo.depuis_votre_espace_vous_pouvez_importer_u"),
      t("seo.le_copilote_ia_repond_a_vos_questions_sur"),
      t("seo.vos_donnees_restent_strictement_privees_ch"),
      t("seo.vous_pouvez_egalement_ajuster_a_tout_momen"),
    ],
  },
  "/register": {
    title: t("seo.creer_un_compte_gratuit_mymenuprofit_pour"),
    description: t("seo.creez_votre_compte_mymenuprofit_en_une_min"),
    heading: t("seo.commencez_a_piloter_la_marge_de_votre_cart"),
    body: [
      t("seo.creer_un_compte_mymenuprofit_prend_moins_d"),
      t("seo.mymenuprofit_n_est_ni_une_caisse_ni_un_log"),
      t("seo.prenez_en_photo_une_facture_de_votre_bouch"),
      t("seo.des_qu_un_prix_augmente_une_alerte_verte_o"),
      t("seo.le_tableau_de_bord_rassemble_l_essentiel_c"),
    ],
  },
  "/forgot-password": {
    title: t("seo.mot_de_passe_oublie_mymenuprofit"),
    description: t("seo.reinitialisez_le_mot_de_passe_de_votre_com"),
    heading: t("seo.retrouvez_l_acces_a_votre_espace_en_toute"),
    body: [
      t("seo.vous_avez_oublie_le_mot_de_passe_de_votre"),
      t("seo.ce_lien_est_valable_pendant_une_heure_et_n"),
      t("seo.si_vous_ne_voyez_pas_l_e_mail_verifiez_vot"),
      t("seo.vos_donnees_de_rentabilite_ne_sont_jamais"),
      t("seo.pour_proteger_votre_compte_choisissez_un_m"),
    ],
  },
  "/reset-password": { title: t("seo.nouveau_mot_de_passe_mymenuprofit"), description: t("seo.choisissez_un_nouveau_mot_de_passe_pour_vo"), ...PRIVATE },
  "/dashboard": { title: t("seo.tableau_de_bord_mymenuprofit"), description: t("seo.cout_matiere_marge_et_plats_les_plus_renta"), ...PRIVATE },
  "/invoices": { title: t("seo.factures_mymenuprofit"), description: t("seo.importez_et_verifiez_vos_factures_fourniss"), ...PRIVATE },
  "/ingredients": { title: t("seo.ingredients_mymenuprofit"), description: t("seo.prix_d_achat_et_historique_de_vos_ingredie"), ...PRIVATE },
  "/recipes": { title: t("seo.recettes_mymenuprofit"), description: t("seo.fiches_recettes_cout_de_revient_et_marge_p"), ...PRIVATE },
  "/alerts": { title: t("seo.alertes_mymenuprofit"), description: t("seo.hausses_de_prix_detectees_sur_vos_ingredie"), ...PRIVATE },
  "/copilot": { title: t("seo.copilote_ia_mymenuprofit"), description: t("seo.posez_vos_questions_sur_la_rentabilite_de"), ...PRIVATE },
  "/ma-carte": { title: t("seo.ma_carte_mymenuprofit"), description: t("seo.analyse_de_votre_carte"), ...PRIVATE },
  "/settings": { title: t("seo.parametres_mymenuprofit"), description: t("seo.nom_du_restaurant_et_objectif_de_cout_mati"), ...PRIVATE },
  "/admin/users": { title: t("seo.utilisateurs_mymenuprofit"), description: t("seo.administration_des_comptes"), ...PRIVATE },
  "/admin/visitors": { title: t("seo.visiteurs_mymenuprofit"), description: t("seo.provenance_des_visiteurs"), ...PRIVATE },
};

export const seoFor = (path) => SEO[path]
  || (path.startsWith("/recipes") && { title: t("seo.recette_mymenuprofit"), description: t("seo.edition_d_une_fiche_recette"), ...PRIVATE })
  || (path.startsWith("/ma-carte") && SEO["/ma-carte"])
  || SEO["/"];
